import requestUtil from '../request-utils.js'
import {
	getSingleParam
} from './api-params.js'

/**
 * 生成商品详情短链
 */
async function getMinAppShotLinkForGoodsDetail(goodsId, goodsName) {
	// 获取小程序Id
	let appId = await getSingleParam("appid");
	// 测试代码
	// let appId ="wx14f1ae5809d89e66";
	// 未授权小程序则不处理
	if (!appId) {
		return "";
	}

	// 生成短链的参数
	let path = `subpackages/goods/goodsdetail/goodsdetail?goodsId=${goodsId}`;
	// 生成链接
	let shotLink = await _getMinAppShotLinkFromOrigin(appId, path, goodsName);
	return shotLink;
}

/**
 * 生成短链
 */
function _getMinAppShotLinkFromOrigin(appId, path, title) {
	return new Promise((resolve, reject) => {
		requestUtil.jackyunPost({
			method: 'jmall.wxplat.getshotlink',
			jsonStr: JSON.stringify({
				authAppId: appId,
				page_url: path,
				page_title: title,
				is_permanent: true
			})
		}, (res => {
			let data = "";
			if (res.code == 200 && res.result.data && res.result.data.errcode == 0) {
				data = res.result.data.link || "";
			} else {
				console.log("生成小程序短链失败：", res);
			}
			resolve(data);
		}));
	});
}

export {
	getMinAppShotLinkForGoodsDetail,
}